<template>
  <div class="pdf-preview">
      <div id="pdfmodal"></div>
  </div>
</template>

<script>
import PDFObject from 'pdfobject'

export default {
  name: 'pdf-preview',
  props: {
    url: String
  },
  created() {
    this.$nextTick(function () {
      if (this.url && this.url.length > 0) {
        this.setPdf(this.url)
      }
    })
    this.$root.$on('openPdfPreview', (url) => {
      this.setPdf(url)
    })
  },
  methods: {
    setPdf(url) {
      PDFObject.embed(url, '#pdfmodal')
    }
  }
}
</script>
